import { useMemo } from "react";

// Use this interface for your table component to manage the state
export interface UseTablePaginationProps<T> {
  data: T[];
  activePage: number;
  rowsPerPage: number;
}

// Return only the paginated data
export interface UseTablePaginationReturnType<T> {
  paginatedData: T[];
}

export function useTablePagination<T>({
  data,
  activePage,
  rowsPerPage,
}: UseTablePaginationProps<T>): UseTablePaginationReturnType<T> {
  const paginatedData = useMemo(() => {
    const start = (activePage - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return data.slice(start, end);
  }, [data, activePage, rowsPerPage]);

  return { paginatedData };
}
